import gql from 'graphql-tag'

export default gql`
  mutation SaveOrderMutation($input: SaveOrderInput!) {
    saveOrder(input: $input) {
      status
    }
  }
`
